<template>
  <div :class="['page', `page--step${$root.step}`]">
    <header class="page__header">
      <Header />
    </header>
    <section class="page__wrapper">
      <router-view />
    </section>
    <footer class="page__footer">
      <Footer />
    </footer>
  </div>
</template>

<script>
  import Header from "@/components/header/Header.vue";
  import Footer from "@/components/footer/Footer.vue";
  export default {
    components: { Header, Footer }
  };
</script>
<style lang="scss">
  @import "~@/assets/scss/base";
  .page {
    @include media('>lg') {
      padding: 0 rem(40);
      width: 50vw;
      min-height: 100vh;
      position: relative;
    }
    @include media('<=lg') {
      padding: 0 rem(16);
    }
    &__header {
      @include media('>lg') {
        margin: 0 rem(-40);
      }
      @include media('<=lg') {
        margin: 0 rem(-16);
      }
    }
    &__footer {
      @include media('>lg') {
        position: fixed;
        box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
        z-index: 2;
        background: #fff;
        right: 1rem;
        top: 1rem;
      }
      @include media('<=lg') {
        background: $light-bg-color;
        margin: 0 rem(-16);
      }
    }
    @include media('>lg') {
      &:after {
        position: fixed;
        z-index: 1;
        right: 0;
        top: 0;
        bottom: 0;
        left: 50vw;
        content: '';
        background: $primary-color no-repeat 50% / cover;
      }
      @for $i from 1 through 4 {
        &--step#{$i} {
          &:after {
            background-image: url('~@/assets/images/backgrounds/step#{$i}.jpg');
            @media (min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
              background-image: url('~@/assets/images/backgrounds/step#{$i}@2x.jpg');
            }
            @media (min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
              background-image: url('~@/assets/images/backgrounds/step#{$i}@3x.jpg');
            }
          }
        }
      }
    }
  }
</style>
